import React, { useCallback } from "react";
import { Close as CloseIcon, Search as SearchIcon } from "@mui/icons-material";
import { TextField } from "@mui/material";
import { Box } from "@mui/system";

import { CATALOG_SECTIONS_INFO } from "./catalog-tab-layout-constants";
import { CatalogTabLayoutProps } from "./catalog-tab-layout-types";
import { catalogTabpanelStyles } from "./catalog-tab-layout.style";

export const CatalogTabLayout = (props: CatalogTabLayoutProps): JSX.Element | null => {
  const { children, type, onSearch, searchText, actions } = props;
  const classes = catalogTabpanelStyles();

  const catalogTabInfo = CATALOG_SECTIONS_INFO[type];

  const onSubmit = useCallback((e) => {
    e.preventDefault();
  }, []);

  const onSearchChange = useCallback(
    (text: React.ChangeEvent<HTMLInputElement>) => onSearch(text.target.value),
    [onSearch]
  );

  const onSearchClear = useCallback(() => onSearch(""), [onSearch]);

  return (
    <Box sx={classes.root}>
      <Box sx={classes.manualHeader}>{catalogTabInfo.name}</Box>
      <Box
        component="form"
        sx={classes.inputSearch}
        noValidate
        autoComplete="off"
        onSubmit={onSubmit}
      >
        <TextField
          id="catalog-tab-layout-search-field"
          variant="outlined"
          slotProps={{
            htmlInput: {
              "aria-label": "Полнотекстовый поиск внутри каталога",
            },
            input: {
              endAdornment: (
                <>
                  {searchText.length > 0 && (
                    <CloseIcon
                      key="closeIcon"
                      onClick={onSearchClear}
                      sx={{ cursor: "pointer" }}
                    />
                  )}
                  <SearchIcon key="searchIcon" />
                </>
              ),
            },
          }}
          label="Найти"
          onChange={onSearchChange}
          size="small"
          value={searchText}
          sx={classes.searchField}
        />
        {actions && <Box sx={classes.actions}>{actions}</Box>}
      </Box>
      <Box>{children}</Box>
    </Box>
  );
};
